import moment from 'moment';

export function isoToFormatted(value, format) {
    if (!value || (value.length !== 24 && value.length !== 10)) {
        return null;
    }

    return moment.utc(value).format(format);
}

export function formattedToIso(value, format) {
    // Extra check because we dont want to parse partial inputs
    if (!value || value.length !== format.length) {
        return null;
    }

    const date = moment.utc(value, format);
    if (date.isValid()) {
        return date.toISOString();
    } else {
        return null;
    }
}

export function getToday() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}

/**
 * Returns the week number for this date.  dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
export function getWeek(date, dowOffset) {
    dowOffset = typeof dowOffset === 'number' ? dowOffset : 0; //default dowOffset to zero

    var newYear = new Date(date.getFullYear(), 0, 1);
    var day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = day >= 0 ? day : day + 7;
    var daynum =
        Math.floor(
            (date.getTime() -
                newYear.getTime() -
                (date.getTimezoneOffset() - newYear.getTimezoneOffset()) *
                60000) /
            86400000
        ) + 1;
    var weeknum;
    //if the year starts before the middle of a week
    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            let nYear = new Date(date.getFullYear() + 1, 0, 1);
            let nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
             the week, it is week #1 of that year*/
            weeknum = nday < 4 ? 1 : 53;
        }
    } else {
        weeknum = Math.floor((daynum + day - 1) / 7);
    }
    return weeknum;
}

/**
 * Checks if the given date is in the future or today.
 * Date should be as YYYY-MM-DD
 * @param date
 * @returns {boolean} true if the date is in the future.
 */
export function isFutureDateOrToday(date) {
    const today = new Date();
    date = date.split('-');
    date = new Date(date[0], date[1] - 1, date[2]);
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return today.getTime() - date.getTime() <= 0 ? true : false;
}

/**
 * Checks if the given date is in the future.
 * Date should be as YYYY-MM-DD
 * @param date
 * @returns {boolean} true if the date is in the future.
 */
export function isFutureDate(date) {
    const today = new Date();
    date = date.split('-');
    date = new Date(date[0], date[1] - 1, date[2]);
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return today.getTime() - date.getTime() < 0 ? true : false;
}

// parse a date in yyyy-mm-dd format
export function parseDate(input) {
    const parts = input.split('-');
    return new Date(parts[0], parts[1] - 1, parts[2]); // Note: months are 0-based
}

export function dateToDmY(date, separator = '-') {
    const days = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return (
        days.toString().padStart(2, '0') +
        separator +
        month.toString().padStart(2, '0') +
        separator +
        year
    );
}

export function dateToYmd(date, separator = '-') {
    const days = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return (
        year +
        separator +
        month.toString().padStart(2, '0') +
        separator +
        days.toString().padStart(2, '0')
    );
}

export function secondsToHoursMinutesSeconds(secs) {
    let sign = secs < 0 ? '-' : '';
    secs = Math.abs(secs);

    return (
        sign +
        z((secs / 3600) | 0) +
        ':' +
        z(((secs % 3600) / 60) | 0) +
        ':' +
        z(secs % 60)
    );

    function z(n) {
        return (n < 10 ? '0' : '') + n;
    }
}

export function getSlashDate(dateStr) {
    if (!dateStr) {
        return '/';
    }

    let date = new Date(dateStr);

    if (isNaN(date.getTime())) {
        date = new Date(dateStr.replace(' ', 'T'));

        const split = dateStr.split(/[- :]/);

        date = new Date(
            split[0],
            split[1] - 1, // months are 0-based
            split[2],
            split[3],
            split[4],
            split[5]
        );
    }

    return (
        date.getDate().toString().padStart(2, '0') +
        '/' +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        '/' +
        date.getFullYear()
    );
}
